export enum CreatedBy {
    Self = 'self',
    Office = 'office',
    Group = 'group',
}
